import { Container, Form, FormTheme } from '@submize/form';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AutoFields from '../Autofields';
import {
  getFields, setFields, moveTo, setSelected,
} from './editorSlice';
import { getForm, getFormDesign } from '../../FormSetup/formSlice';

const Editor = ({ form }) => {
  const dispatch = useDispatch();
  const fields = useSelector(getFields);
  const design = useSelector(getFormDesign);
  const { dirty } = useSelector(getForm);

  useEffect(() => {
    if (!dirty) {
      const fs = form.schema?.form.children || [];
      const ff = fs.map((field) => ({
        ...field,
        schema: form.schema.schema.keys[field.key],
      }));
      if (!ff.find((f) => f.type === 'Submit')) {
        ff.push({
          type: 'Submit',
          key: 'submit',
          props: {
            label: {
              value: 'Submit',
            },
          },
        });
      }
      dispatch(setFields(ff));
    }
  }, [dirty]);

  const moveField = useCallback((from, to, field) => {
    dispatch(moveTo({ from, to }));
    dispatch(setSelected(field));
  }, []);

  return (
    <FormTheme design={design}>
      <Container design={design}>
        <Form isAdmin>
          <AutoFields fields={fields} moveField={moveField} />
        </Form>
      </Container>
    </FormTheme>
  );
};

export default Editor;
